import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import withModal from "../withModal";

export const SINGLE_SEGMENT_SELECTION_VALIDATION_MODAL = "SINGLE_SEGMENT_SELECTION_VALIDATION";

export const SINGLE_SEGMENT_SELECTION_VALIDATION_MESSAGE =
    "The partner audience provider you selected does not currently support including more than one segment in a flow. " +
    "To continue, please only include one segment in your selections, or select a different partner audience provider.";

interface ISingleSegmentSelectionValidationModal {
    isOpen: boolean;
}

export const SingleSegmentSelectionValidationModal: React.FC<ISingleSegmentSelectionValidationModal> = ({
    isOpen,
}: ISingleSegmentSelectionValidationModal) => {
    const dispatch = useDispatch();

    const hide = () => {
        dispatch(hideModal(SINGLE_SEGMENT_SELECTION_VALIDATION_MODAL));
    };

    return (
        <MaterialModal
            id="single-segment-selection-validation-modal"
            isOpen={isOpen}
            title="Validation Error"
            primaryButtonText="OK"
            onClose={hide}
            onPrimaryButtonRequest={hide}
            showPrimaryButton={true}
            disableEscape={true}
            maxWidth="sm"
        >
            <div>
                <span>{SINGLE_SEGMENT_SELECTION_VALIDATION_MESSAGE}</span>
            </div>
        </MaterialModal>
    );
};

export default withModal(SingleSegmentSelectionValidationModal, SINGLE_SEGMENT_SELECTION_VALIDATION_MODAL);
